// Helpers seguros para acceder a APIs del navegador (evitan romper en SSR).

export function isBrowserEnvironment(): boolean {
  return typeof window !== 'undefined';
}

export function getBrowserWindow(): (Window & typeof globalThis) | null {
  return isBrowserEnvironment() ? window : null;
}

export function getLocationHref(): string {
  return getBrowserWindow()?.location.href ?? '';
}

export function getDocumentReferrer(): string {
  return isBrowserEnvironment() ? document.referrer : '';
}

/** Clasifica el dispositivo por ancho de viewport + user agent (phone/tablet/desktop). */
export function getDeviceType(): 'phone' | 'tablet' | 'desktop' {
  const win = getBrowserWindow();
  if (!win) return 'desktop';

  const width = win.innerWidth;
  const userAgent = win.navigator.userAgent.toLowerCase();
  const isTabletUA = /ipad|tablet|playbook|silk|android(?!.*mobile)/.test(userAgent);

  if (isTabletUA || (width >= 768 && width < 1024)) return 'tablet';
  if (width < 768) return 'phone';
  return 'desktop';
}
